// Shared font picker list used by the CMS Landing Page Editor.
// Google-Fonts entries (Fredoka, Poppins, Bubblegum Sans, Caveat, Inter,
// Comic Neue) are pre-loaded via index.css. The remaining classic
// system / installed fonts (Impact, Arial, Times New Roman, etc.) will
// render natively for users that have them installed and fall back to
// the generic family otherwise — exactly matching the user's request
// without dragging tens of MB of font files into the bundle.
export const FONT_FAMILIES = [
  { label: 'Fredoka',                    value: '"Fredoka", sans-serif' },
  { label: 'Poppins',                    value: '"Poppins", sans-serif' },
  { label: 'Bubblegum Sans',             value: '"Bubblegum Sans", cursive' },
  { label: 'Caveat',                     value: '"Caveat", cursive' },
  { label: 'Inter',                      value: '"Inter", sans-serif' },
  { label: 'Comic Neue',                 value: '"Comic Neue", cursive' },
  { label: 'Bradley Hand ITC',           value: '"Bradley Hand ITC", "Bradley Hand", cursive' },
  { label: 'Forte',                      value: 'Forte, "Caveat", cursive' },
  { label: 'Snap ITC',                   value: '"Snap ITC", "Fredoka", sans-serif' },
  { label: 'Rage Italic',                value: '"Rage Italic", "Caveat", cursive' },
  { label: 'Impact',                     value: 'Impact, "Anton", "Fredoka", sans-serif' },
  { label: 'Tempus Sans ITC',            value: '"Tempus Sans ITC", "Bubblegum Sans", sans-serif' },
  { label: 'Ink Free',                   value: '"Ink Free", "Caveat", cursive' },
  { label: 'Arial',                      value: 'Arial, sans-serif' },
  { label: 'Times New Roman',            value: '"Times New Roman", Times, serif' },
  { label: 'Showcard Gothic',            value: '"Showcard Gothic", Impact, sans-serif' },
  { label: 'The Serif Hand Extrablack',  value: '"The Serif Hand Extrablack", "Caveat", cursive' },
  { label: 'Stencil',                    value: 'Stencil, Impact, sans-serif' },
];

// Helper — resolve a font label OR raw CSS value to a valid CSS font-family
// string. Lets the CMS store either format (older records use bare labels
// like "Fredoka", newer records store the full CSS stack).
export const resolveFontFamily = (val, fallback = '"Fredoka", sans-serif') => {
  if (!val) return fallback;
  const hit = FONT_FAMILIES.find((f) => f.label === val || f.value === val);
  return hit ? hit.value : val;
};
